export const data = {
	storeLetterGroupSize: 18,
	informativeFaqGroupId: 10,
};
